<div class="cardwheader">
  <div
    class="cardwheader__header cardwheader__header--{{ this.color }}"
    [ngClass]="{ 'cardwheader__header--headeronly': this.headerOnly }"
  >
    {{ this.title }}
  </div>
  @if (!this.headerOnly) {
<div class="cardwheader__body">
    <ng-content />
  </div>
}
</div>
